import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';

import { BucketIcon } from 'assets/icons';

import { DeleteIconWrapper } from './DeleteIcon.styled';

interface IDeleteIcon {
  disabled: boolean;
  onClick?: () => void;
  tooltipText: string;
}

export const DeleteIcon = ({ disabled, onClick, tooltipText }: IDeleteIcon) => {
  const { t } = useTranslation();

  return (
    <DeleteIconWrapper
      onClick={!disabled ? onClick : undefined}
      data-tip={t(tooltipText)}
      data-for="deleteTooltip"
    >
      <BucketIcon />
      {tooltipText && (
        <ReactTooltip
          place="top"
          type="dark"
          effect="solid"
          id="deleteTooltip"
          multiline={true}
          delayShow={1000}
        />
      )}
    </DeleteIconWrapper>
  );
};
